<template>
    <div class="py-4 mb-5">
        <div class="row">
            <div class="col-12">
                <button type="button" @click="quickBidCreate" class="btn btn-primary" data-toggle="modal" data-target="#quickBidCreate"><i class="fa fa-plus mr-2"></i>
                    Yeni Teklif Oluştur
                </button>
            </div>
        </div>
        <div class="row mb-3" v-for="(offer,index) in offerData" :key="index" @click="offerCard(index)">
            <div class="col-12 mt-4">
                <div class="card" v-if="index<1">
                    <div class="card-header bg-dark d-flex justify-content-between">
                        <h6 class="text-white my-auto">Referans No: {{offer.referenceNo}}</h6>
                        <h6 class="text-white my-auto">Güncel Versiyon</h6>
                    </div>
                    <div class="card-body">
                        <div class="row disBorder">
                            <div class="col-9 borderr d-flex align-items-center ">
                                <label><b>Sahibi:</b></label>
                                <label class="pl-2">{{holderName}}</label>
                            </div>
                            <div class="col-3 d-flex align-items-center " style="background-color:#E9EAEB">
                                <label><b>Tutar:</b></label>
                                <label class="pl-2" v-if="offer.totalPrice">{{offer.totalPrice.toFixed(2)}}</label>
                            </div>
                        </div>
                        <div class="row disBorder mt-2 borderr h72 pt-2">
                            <label class="col-2 pr-0" style="max-width:100px;"><b>İlgili Kişiler:</b></label>
                            <div class="col-5 pl-0">
                                <label class="row pb-1" v-for="i in offer.contacts">{{i.n + ' ' + i.sn}}</label>
                            </div>
                        </div>
                        <div class="row disBorder mt-2">
                            <div class="col-6 borderr d-flex align-items-center border-right">
                                <label><b>Geçerlilik Tarihi</b></label>
                                <label class="pl-2">{{offerDateFunc(index,'expire')}}</label>
                            </div>
                            <div class="col-6 d-flex align-items-center">
                                <label><b>Oluşturma Tarihi</b></label>
                                <label class="pl-2">{{offerDateFunc(index,'add')}}</label>
                            </div>
                        </div>
                        <div class="row disBorder">
                            <div class="col-6 borderr d-flex align-items-center border-right">
                                <label><b>Gönderim Tarihi</b></label>
                                <label class="pl-2">{{offerDateFunc(index,'send')}}</label>
                            </div>
                            <div v-if="offer.isOffered==true" class="col-6 d-flex align-items-center" style="background: #6FCF97;">
                                <label><b><i class="fas fa-check mr-2"></i>Gönderim Yapıldı</b></label>
                            </div>
                            <div v-else class="col-6 d-flex align-items-center" style="background: #F2C94C;">
                                <label><b><i class="fas fa-times mr-2"></i>Gönderim Yapılmadı</b></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-else>
                    <div class="card-header d-flex justify-content-between" style="background:#898989;">
                        <h6 class="text-white my-auto">Referans No: {{offer.referenceNo}}</h6>
                        <h6 class="text-white my-auto">{{offerVersion(index)}}</h6>
                    </div>
                    <div class="card-body">
                        <div class="row disBorder">
                            <div class="col-9 borderr d-flex align-items-center ">
                                <label><b>Sahibi:</b></label>
                                <label class="pl-2">{{holderName}}</label>
                            </div>
                            <div class="col-3 d-flex align-items-center " style="background-color:#E9EAEB">
                                <label><b>Tutar:</b></label>
                                <label class="pl-2" v-if="offer.totalPrice">{{offer.totalPrice.toFixed(2)}}</label>
                            </div>
                        </div>
                        <div class="row disBorder mt-2 borderr h72 pt-2">
                            <label class="col-2 pr-0" style="max-width:100px;"><b>İlgili Kişiler:</b></label>
                            <div class="col-5 pl-0">
                                <label class="row pb-1" v-for="i in offer.contacts">{{i.n + ' ' + i.sn}}</label>
                            </div>
                        </div>
                        <div class="row disBorder mt-2">
                            <div class="col-6 borderr d-flex align-items-center border-right">
                                <label><b>Geçerlilik Tarihi</b></label>
                                <label class="pl-2">{{offerDateFunc(index,'expire')}}</label>
                            </div>
                            <div class="col-6 d-flex align-items-center">
                                <label><b>Oluşturma Tarihi</b></label>
                                <label class="pl-2">{{offerDateFunc(index,'add')}}</label>
                            </div>
                        </div>
                        <div class="row disBorder">
                            <div class="col-6 borderr d-flex align-items-center border-right">
                                <label><b>Gönderim Tarihi</b></label>
                                <label class="pl-2">{{offerDateFunc(index,'send')}}</label>
                            </div>
                            <div v-if="offer.isOffered==true" class="col-6 d-flex align-items-center" style="background: #6FCF97;">
                                <label><b><i class="fas fa-check mr-2"></i>Gönderim Yapıldı</b></label>
                            </div>
                            <div v-else class="col-6 d-flex align-items-center" style="background: #F2C94C;">
                                <label><b><i class="fas fa-times mr-2"></i>Gönderim Yapılmadı</b></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add New Offer Modal -->
        <div class="modal fade" id="quickBidCreate" data-backdrop="static" data-keyboard="false" aria-hidden="true" aria-labelledby="quickBidCreateLabel" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" style="max-width:700px;">
                <div class="modal-content">
                    <div class="modal-header px-4 pt-3">
                        <h5 class="modal-title" id="quickBidCreateLabel">{{$ml.get('QUICK_BID_CREATION')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">&times;</button>
                    </div>
                    <div class="modal-body px-4">
                        <div class="row">
                            <div class="col">
                                <label class="new-label mb-2">{{$ml.get('TEMPLATE')}}*</label> 
                                <div class="bg-white">
                                    <select class="new-input mb-3 bg-white" @change="chooseTemplate($event)">
                                        <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                        <option v-for="template in emailTemplates">{{template.name}}</option>
                                    </select>
                                </div>
                            </div>
                            
                        </div>  
                        <div class="row">
                            <div class="col">
                                <label class="new-label mb-2">{{$ml.get('COMPANY')}}*</label>                             
                                <input type="text" disabled v-model="organizationName" class="new-input">
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <button type="button" class="btn btn-primary px-4" @click="getMatchContacts()" data-toggle="modal" data-target="#matchContactsModal">
                                    {{$ml.get('MATCH_CONTACTS')}}
                                </button>
                            </div>
                        </div>
                        <div class="row mt-3" v-for="(item, index) in listPersons" :key="index">
                            <div class="col-md-10 mx-3 listPerson">
                                {{item.name}}
                            </div>
                            <div class="col-md-1 ml-2">
                                <a class="btn btn-danger trash-icon" @click="deletePerson(index)">
                                <i class="far fa-trash-alt text-white"></i>
                                </a>
                            </div>
                        </div>
                        <div class="row mt-4">  
                            <div class="col-12"> 
                                <label class="new-label mb-2">{{$ml.get('VALIDITY_DATE')}}*</label> 
                            </div>                         
                            <div class="col-md-6">
                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="activityDateAction" class="new-ctk" v-model="activityDateAction" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SELECT_DATE')"></vue-ctk-date-time-picker>
                            </div>
                            <div class="col-md-6">
                                <button type="button" class="btn btn-primary px-4" @click="redirectToBidScreen">
                                    {{$ml.get('REDIRECT_TO_BID_SCREEN')}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer ">
                        <div class="row mt-2">
                            <div class="col-12 dealBtnStyle">
                                <button class="btn-new save dropdown-toggle d-flex align-items-center justify-content-around" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SAVE')}}</button>
                                <button class="btn-new gri" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                                <div class="dropdown">
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button class="dropdown-item" type="button" @click="saveAndEmail('save')" >Teklifi Kaydet</button>
                                        <button class="dropdown-item" type="button" @click="saveAndEmail('saveAndEmail')" >Kaydet ve e-posta ile gönder</button>
                                        <button class="dropdown-item" @click="saveOffer('print')" type="button">Kaydet ve Yazdır</button>
                                        <button class="dropdown-item" @click="saveOffer('download')" type="button">Kaydet ve PDF olarak indir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Kişileri Eşleştir Modal -->
        <div class="modal fade" id="matchContactsModal" tabindex="-1" aria-labelledby="matchContactsModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:720px!important">
            <div class="modal-content">
                <div class="modal-header py-0 d-flex align-items-center">
                    <h2 class="modal-title p-2 ">Teklifin gönderileceği ilgili kişileri seç</h2>
                    <button type="button" aria-label="Close" class="close" data-dismiss="modal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-5 px-md-4 ">
                    <div class="row mx-2 ">   
                        <div class="personTable">
                        
                        <table class="table table-striped table-hover" id="contactTable">
                            <thead>
                            <tr>
                                <th>
                                    <label class="form-checkbox">
                                        <input type="checkbox" v-model="selectAll" id="select-all" @click="selectPerson()">
                                        <i class="form-icon"></i>
                                    </label>
                                </th>
                                <th>{{$ml.get('PERSON')}}</th>
                                <th>Pozisyon</th>
                                <th>{{$ml.get('EMAIL')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="i in personData">
                                <td>
                                <label class="form-checkbox">
                                    <input type="checkbox" :value="i._id.$oid" v-model="selected" >
                                    <i class="form-icon"></i>
                                    </label>
                                </td>
                                <td>{{i.n +" "+ i.sn}}</td>
                                <td>{{i.jobTitle}}</td>
                                <td v-if="i.email">{{i.email[0]}}</td>
                                <td v-else></td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-4">
                        <div class="col-12">
                            <button class="btn btn-primary float-right px-3" @click="matchContactsSave">{{$ml.get('SAVE')}}</button>
                            <button class="btn float-right mr-2 px-3" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                        </div>
                    </div>
                </div>

            </div>
          </div>
        </div>

        <!-- Teklif Oluşturma Modal -->
        <div class="modal createBidModal my-5" tabindex="-1" id="TeklifEkraniModal" data-backdrop="static" aria-labelledby="TeklifEkraniModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:1100px!important;">
                <div class="modal-content " style="max-height: 100%; position: fixed;">
                    <div class="modal-header d-flex align-items-center py-0 crm-modal-header">
                        <h5 class="modal-title p-2 ">Teklif Oluşturma </h5>
                        <button type="button" class="close" aria-label="Close" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body pt-5 crm-modal-body" style="height: 750px;">
                        <div class="row mb-3">
                            <div class="col-6 d-flex align-items-baseline">
                                <label class="new-label float-left black fs16 mx-2 ">Şablon Seçiniz</label>
                                <select class="new-input bg-white ml-2" style="width:250px;" @change="chooseTemplate($event)">
                                    <option disabled selected value="">{{$ml.get('SELECT')}}</option>
                                    <option v-for="template in emailTemplates" :value="template._id" :key="template._id" :selected="chosenTemplate===template._id">{{template.name}}</option>
                                </select>
                            </div>
                            <div class="col-6 float-right">
                                <button type="button" class="btn btn-primary float-right px-4" @click="createNewTemplate()">Yeni Şablon Oluştur</button>
                            </div>
                        </div>
                        <div class="container border mx-1 my-3">
                            <div class="row">
                                <div class="col companyInfo">
                                    <label class="new-label black"><b>Şirket Bilgileri</b></label>
                                </div>
                            </div>
                            <div class="row py-3" style="background:#FFFFFF; border-radius: 8px;">
                                <!-- <div class="col-md-3">
                                    <label class="new-label float-left mb-2"><b>Firma Logosu</b></label>
                                    <img src="" class="logo" alt="">
                                </div> -->
                                <div class="col-md-6 d-flex flex-column">
                                    <label class="new-label label-title-color float-left"><b>Şirketinizin Adı</b></label>
                                    <label class="mt-2">{{organizationName}}</label>
                                </div>
                                <div class="col-md-6 d-flex flex-column">
                                
                                    <label class="new-label label-title-color float-left mb-2" ><b>Şirketinizin Bilgileri</b></label>

                                    <div class="row my-2">
                                        <label class="col-md-3 new-label label-title-color"><b>Adres:</b></label>
                                        <div class="col-md-8  pl-0">
                                        <label class=" mb-0 mt-0">{{organizationData.addr}}</label>
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <label class="col-md-3 new-label label-title-color float-left"><b>Telefon:</b></label>
                                        <div class="col-md-8 pl-0">
                                            <div v-for="i in organizationData.phoneNumbers">
                                                <label class=" mb-0 mt-0">{{i}}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-2">
                                        <label class="col-md-3 new-label label-title-color float-left"><b>E-posta:</b></label>
                                        <div class="col-md-8 pl-0">
                                            <div v-for="i in organizationData.emailAddresses">
                                                <label class=" mb-0 mt-0">{{i}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            
                        </div>
                        <div class="container border mx-1 my-3">
                            <div class="row">
                                <div class="col companyInfo">
                                    <label class="new-label black"><b>Teklif</b></label>
                                </div>
                            </div>
                            <div class="row py-4" style="background:#FFFFFF; border-radius: 8px;">
                                <div class="col-md-7 mb-2">
                                    <div class="row my-2">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16">
                                                <b>Teklif Başlığı</b></label>
                                        </div>
                                        <div class="col-md-9">
                                            <input type="text" v-model="offerTitle" class="new-input label-desc-color h36">
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                            <div class="col-md-3">
                                                <label class="new-label label-title-color fs16">
                                                    <b>Firma Adı*</b></label>
                                            </div>
                                            <div class="col-md-9">
                                                <input type="text" disabled="disabled" v-model="organizationName" class="new-input label-desc-color bg-date-not h36">
                                            </div>
                                    </div>
                                    <div class="row my-1">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16">
                                                <b>İlgili Kişi*</b></label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="row mb-2" v-for="(item, index) in listPersons" :key="index">
                                                <div class="col-md-7 ml-3 listPerson">
                                                {{item.name}}
                                                </div>
                                                <div class="col-md-1 ">
                                                <a class="btn btn-danger trash-icon hw36" @click="deletePerson(index)">
                                                    <i class="far fa-trash-alt text-white"></i>
                                                </a>
                                                </div>
                                                <div class="col-md-1 ml-2">
                                                <button class="btn btn-primary hw36 ml-2" data-toggle="modal" data-target="#matchContactsModal">
                                                    <span class="fa fa-plus "></span>
                                                </button>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                    <div class="row my-1">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16">
                                                <b>İlgili Fırsat*</b></label>
                                        </div>
                                        <div class="col-md-9 d-flex">
                                            <input type="text" disabled v-model="deal.title" class="new-input label-desc-color bg-date-not h36">
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-3">
                                        <label class="new-label label-title-color fs16">
                                            <b>Fatura Adresi</b></label>
                                        </div>
                                        <div class="col-md-8 d-flex">
                                            <textarea v-if="!isEditableBill" type="text" v-model="billAddress" disabled class="new-textarea label-desc-color bg-date-not pl-3"></textarea>
                                            <textarea v-if="isEditableBill" type="text" v-model="billAddress" class="new-textarea label-desc-color pl-3"></textarea>
                                        </div>
                                        <div class="col-md-1 pl-0">
                                            <button v-if="!isEditableBill" @click="isEditableBill=!isEditableBill" class="btn btn-primary hw36 ">
                                                <span class="fa fa-pencil"></span>
                                            </button>
                                            <button v-if="isEditableBill" @click="isEditableBill=!isEditableBill" class="btn btn-success hw36">
                                                <span class="fas fa-check"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16">
                                            <b>Sevkiyat Adresi</b></label>
                                        </div>
                                        <div class="col-md-8 ">
                                            <textarea v-if="!isEditableShipping" type="text" v-model="shippingAddress" disabled class="new-textarea label-desc-color bg-date-not pl-3"></textarea>
                                            <textarea v-if="isEditableShipping" type="text" v-model="shippingAddress" class="new-textarea label-desc-color pl-3"></textarea>
                                        </div>
                                        <div class="col-md-1 pl-0">
                                            <button v-if="!isEditableShipping" @click="isEditableShipping=!isEditableShipping" class="btn btn-primary hw36">
                                                <span class="fa fa-pencil"></span>
                                            </button>
                                            <button v-if="isEditableShipping" @click="isEditableShipping=!isEditableShipping" class="btn btn-success hw36">
                                                <span class="fa fa-check"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5" style="border-left:1px solid #D1D1D7;">
                                    <div class="row my-2">
                                        <div class="col-md-4">
                                            <label class="new-label label-title-color fs16">
                                                <b>Referans No</b></label>
                                        </div>
                                            <div class="col-md-8 d-flex">
                                            <input type="text" disabled v-model="referenceNo" class="new-input label-desc-color bg-date-not h36">
                                            </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-4">
                                            <label class="new-label label-title-color fs16">
                                                <b>Tarih*</b></label>
                                        </div>
                                            <div class="col-md-8 d-flex">
                                                <vue-ctk-date-time-picker disabled :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="bidCreationDate" class="new-ctk" v-model="bidCreationDate" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SELECT_DATE')"></vue-ctk-date-time-picker>
                                            </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-4">
                                            <label class="new-label label-title-color fs16">
                                                <b>Son Geçerlilik*</b>
                                            </label>
                                        </div>
                                            <div class="col-md-8 d-flex">
                                                <vue-ctk-date-time-picker :locale="localeLang" :button-now-translation="$ml.get('TODAY')" id="bidCreationExpiryDate" class="new-ctk" v-model="activityDateAction" format="YYYY-MM-DD" formatted="ll" :noLabel="true" :range="false" :onlyDate="true" :auto-close="true" :label="$ml.get('SELECT_DATE')"></vue-ctk-date-time-picker>
                                            </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-4">
                                            <label class="new-label label-title-color fs16">
                                            <b>Para Birimi*</b>
                                            </label>
                                        </div>
                                        <div class="col-md-8 d-flex">
                                            <input type="text" disabled v-model="currencyText" class="new-input label-desc-color bg-date-not h36">
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-4">
                                            <label class="new-label label-title-color fs16">
                                            <b>Vergi Dairesi</b>
                                            </label>
                                        </div>
                                        <div class="col-md-8 d-flex">
                                            <input type="text" disabled v-model="organizationData.taxOffice" class="new-input label-desc-color bg-date-not h36">
                                        </div>
                                    </div>
                                    <div class="row my-2">
                                        <div class="col-md-4">
                                            <label class="new-label label-title-color fs16">
                                            <b>Vergi No</b>
                                            </label>
                                        </div>
                                        <div class="col-md-8 d-flex">
                                            <input type="text" disabled v-model="organizationData.taxNo" class="new-input label-desc-color bg-date-not h36">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container border mx-1 my-1">
                            <div class="row">
                                <div class="col companyInfo">
                                    <label class="new-label black"><b>Başlangıç Metni</b></label>
                                </div>
                            </div>
                        
                            <div class="row py-2" style="background:#FFFFFF; border-radius: 8px;">
                                <div class="col-12 mb-3 new-label text-dark">
                                <form>
                                    <textarea name="editor1" id="editor1" rows="10" cols="80">
                                        
                                    </textarea>
                                </form>
                                
                                </div>
                            </div>
                        </div>
                        <div class="container border mx-1 my-3">
                            <div class="row">
                                <div class="col companyInfo">
                                    <label class="new-label black"><b>Ürün Ekleme Alanı</b></label>
                                </div>
                            </div>
                            <!-- TABLO OLUŞTURMA -->

                            <div class="row" style="background:#FFFFFF; border-radius: 8px;">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>{{$ml.get('PRODUCT_CODE')}}</th>
                                            <th>{{$ml.get('PRODUCT_NAME')}}</th>
                                            <th>Birim Fiyatı</th>
                                            <th>{{$ml.get('PIECE')}}</th>
                                            <th>{{$ml.get('DISCOUNT')}}%</th>
                                            <th>KDV%</th>
                                            <template v-if="otherTaxes.length>0">
                                                <th v-for="(taxItem, taxIdx) in otherTaxes" :key="taxIdx">{{taxItem.name}}</th>
                                            </template>
                                            <th>{{$ml.get('AMOUNT')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(i, prodIdx) in productTableList" :key="prodIdx">
                                            <td>{{i.productId.code}}</td>
                                            <td>{{i.productId.name}}</td>
                                            <!-- <td v-if="i.itemPrice">{{i.itemPrice.toFixed(2)}}</td> -->
                                            <td v-if="i.itemPrice !== undefined && i.itemPrice !== null">
                                                {{ formatPrice(i.itemPrice.toFixed(2)) }}
                                            </td>
                                            <td>{{i.quantity}}</td>
                                            <td>{{i.discountPercentage}}%</td>
                                            <td v-if="i.productId.tax">{{i.productId.tax}}%</td>
                                            <td v-else>0%</td>
                                            <template v-for="(a,index) in otherTaxes" :key="index">
                                                <td v-if="i.productId[a.id]!==undefined">{{i.productId[a.id].value}}%</td>
                                                <td v-else>0%</td>
                                            </template>
                                            <!-- <td v-if="i.sum">{{i.sum.toFixed(2)}}</td> -->
                                            <td v-if="i.sum !== undefined && i.sum !== null">
                                                {{ formatPrice(i.sum.toFixed(2)) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                    
                            <div class="row d-flex justify-content-end" style="background:#FFFFFF; border-radius: 8px;">
                                <div class="col-md-6" >
                                    <table class="table table-bordered product-add-price-table mt-4">
                                        <tbody>
                                            <tr>
                                                <td class="thead-light text-center bg-date-not d-flex justify-content-start">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <label class="switch heightSwitch mr-2">
                                                            <input type="checkbox" v-model="showTotalPriceStatus">
                                                            <span class="slider round true"></span>
                                                        </label>
                                                        <label style="color:black;">Toplam Tutar</label>
                                                    </div>
                                                </td>
                                                <!-- <td class="text-right">{{totalAmount}}</td> -->
                                                <td class="text-right">{{ formatPrice(totalAmount) }}</td>
                                            </tr>
                                            <tr>
                                                <td class="thead-light text-center bg-date-not d-flex justify-content-start">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <label class="switch heightSwitch mr-2">
                                                        <input type="checkbox" v-model="showTotalDiscountStatus">
                                                        <span class="slider round true"></span>
                                                        </label>
                                                        <label style="color:black;">Toplam İndirim</label>
                                                    </div>
                                                </td>
                                                <!-- <td class="text-right">{{totalDiscount}}</td> -->
                                                <td class="text-right">{{ formatPrice(totalDiscount) }}</td>
                                            </tr>
                                            <tr>
                                            <td class="thead-light text-center bg-date-not ">
                                                <div class="d-flex align-items-center">
                                                <label class="ml-5 pl-2" style="color:black;">Ara Toplam</label>
                                                </div>
                                            </td>
                                            <!-- <td class="text-right">{{subTotal}}</td> -->
                                            <td class="text-right">{{ formatPrice(totalDiscount) }}</td>
                                            </tr>
                                            <tr>
                                                <td class="thead-light text-center bg-date-not pl-5">
                                                    <div class="d-flex align-items-center ml-3">
                                                            <label class="black" >Toplam KDV Tutarı</label>
                                                    </div>
                                                </td>
                                                <td class="text-right">{{totalKDV}}</td>
                                            </tr>
                                            <tr>
                                                <td class="thead-light text-center bg-date-not d-flex justify-content-start">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <label class="switch heightSwitch mr-2">
                                                            <input type="checkbox" v-model="showOtherTaxStatus">
                                                            <span class="slider round true"></span>
                                                        </label>
                                                            <label class="black" >Diğer Vergiler Tutarı</label>
                                                    </div>
                                                </td>
                                                <td class="text-right">{{totalTaxes}}</td>
                                            </tr>
                                            <tr>
                                                <td class="thead-light  text-center bg-dark">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                            <label class="text-white" >GENEL TOPLAM </label>
                                                    </div>
                                                </td>
                                                <!-- <td class="text-right">{{generalTotal}}</td> -->
                                                <td class="text-right">{{ formatPrice(generalTotal) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="container border mx-1 my-3">
                            <div class="row">
                                <div class="col companyInfo">
                                    <label class="new-label black"><b>Koşullar</b></label>
                                </div>
                            </div>
                            <div class="row py-2" style="background:#FFFFFF; border-radius: 8px;">
                                <div class="col-12 mb-3 new-label text-dark">
                                <form>
                                    <textarea name="editor2" id="editor2" rows="10" cols="80">
                                    
                                    </textarea>
                                </form>
                                </div>
                            </div>
                        </div>
                        <div class="container border mx-1 my-3">
                            <div class="row">
                                <div class="col companyInfo">
                                    <label class="new-label black"><b>Bitiş Metni</b></label>
                                </div>
                            </div>
                            <div class="row py-2" style="background:#FFFFFF; border-radius: 8px;">
                                <div class="col-12 mb-3 new-label text-dark">
                                <form>
                                    <textarea name="editor3" id="editor3" rows="10" cols="80">
                                    
                                    </textarea>
                                </form>
                                </div>
                            </div>
                        </div>
                        <div class="container mx-1 my-3">
                            <div class="row" >
                                <div class="col-md 6 border mr-4" style="background:#FFFFFF; border-radius: 8px;">
                                    <div class="row">
                                        <div class="col companyInfo">
                                            <label class="new-label black"><b>Teklifi Sunan</b></label>
                                        </div>
                                    </div>
                                    <div class="row my-3" >
                                        <div class="col-md-3">
                                        <label class="new-label label-title-color fs16" >
                                            <b>İsim</b></label>
                                        </div>
                                        <div class="col-md-9 d-flex">
                                            <input type="text" v-model="offererName" class="my-auto dealInput">
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16" >
                                                <b>Görevi</b></label>
                                        </div>
                                        <div class="col-md-9 d-flex">
                                            <input type="text" v-model="offererTitle" class="my-auto dealInput" >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md 6 border" style="background:#FFFFFF; border-radius: 8px;">
                                    <div class="row">
                                        <div class="col companyInfo">
                                            <label class="new-label black"><b>Teklifi Kabul Eden</b></label>
                                        </div>
                                    </div>
                                    <div class="row my-3">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16" >
                                                <b>İsim</b></label>
                                        </div>
                                        <div class="col-md-9 d-flex">
                                            <input type="text" v-model="customerName" class="my-auto dealInput" >
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-3">
                                            <label class="new-label label-title-color fs16" >
                                                <b>Görevi</b></label>
                                        </div>
                                        <div class="col-md-9 d-flex">
                                            <input type="text" v-model="customerTitle" class="my-auto dealInput" >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                    <div class="row mx-0 crm-modal-footer stickyBtn" style="margin-top: 3rem;">
                            <div class="col-12 py-2 dealBtnStyle">
                                <button class="btn-new save dropdown-toggle d-flex align-items-center justify-content-around" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$ml.get('SAVE')}}</button>
                                <button class="btn-new gri" data-dismiss="modal" >{{$ml.get('CANCEL')}}</button>
                                <div class="dropdown">
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                        <button class="dropdown-item" type="button" @click="saveOffer('save')" >Teklifi Kaydet</button>
                                        <button class="dropdown-item" type="button" @click="saveOffer('saveAndEmail')" >Kaydet ve e-posta ile gönder</button>
                                        <button class="dropdown-item" @click="saveOffer('print')" type="button">Kaydet ve Yazdır</button>
                                        <button class="dropdown-item" @click="saveOffer('download')" type="button">Kaydet ve PDF olarak indir</button>
                                    </div>
                                </div>
                            </div>
                    </div>


                </div>
            </div>
        </div>

        <!-- UYARI MODALI -->      
        <div class="modal" id="warningModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="warningModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                <div class="modal-body d-flex">
                    <div class="row mx-auto ">
                        <i class="col-md-12 fas fa-exclamation-circle my-3" style="font-size:80px; left:39%;"></i>
                        <div class="col-md-12 mb-3 text-center" id="warningModalTitle" style="font-weight:bold; font-size:16px;">Tarih Girin</div>
                        <div class="col-md-12 text-center" id="warningModalText" style="font-size:16px;">Teklifin oluşturulması için tarih girilmesi gerekmektedir.</div>
                    </div>
                </div>
                <div class="modal-footer d-flex">
                    <button type="button" class="btn btn-primary mx-auto" style="background:#3767A0;" @click="warningModalClose">{{$ml.get('COMPLETE')}}</button>
                </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex'
import { mapState } from "vuex"
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import axios from "axios"
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import moment from 'moment'
import { formatPrice } from '@/services/gridFormatters'
Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)
const qs = require('qs')

export default {
    name:"bidDetailPanel",
    props:["dealId","deal"],
    data() {
        return {
            offerData:[],
            users:[],
            offerID:"",
            holderName:"",
            chosenTemplate:"",
            emailTemplates:[],
            organizationData:[],
            organizationName:"",
            activityDateAction:"",
            selectAll:"",
            selected:[],
            selectedPersons:[],
            personData:[],
            listPersons:[],
            personEmailsArray:[],
            personIds:[],
            pdfUrl:[],
            isEditableBill:false,
            isEditableShipping:false,
            billAddress:"",
            shippingAddress:"",
            referenceNo:"",
            bidCreationDate:"",
            currencyText:"",
            currenciesData: [
                { value: "1", label: "TL" },
                { value: "2", label: "USD" },
                { value: "3", label: "EUR" },
                { value: "4", label: "AUD" },
                { value: "5", label: "DKK" },
                { value: "6", label: "GBP" },
                { value: "7", label: "CHF" },
                { value: "8", label: "SEK" },
                { value: "9", label: "CAD" },
                { value: "10", label:"KWD" },
                { value: "11", label:"NOK" },
                { value: "12", label:"SAR" },
                { value: "13", label:"JPY" },
                { value: "14", label:"BGN" },
                { value: "15", label:"RON" },
                { value: "16", label:"RUB" },
                { value: "17", label:"IRR" },
                { value: "18", label:"CNY" },
                { value: "19", label:"PKR" },
                { value: "20", label:"QAR" },
            ],
            productTableList:[],
            totalAmount:0,
            totalDiscount:0,
            generalTotal:0,
            subTotal:0,
            totalKDV:0,
            totalTaxes:0,
            offererName:"",
            offererTitle:"",
            customerName:"",
            customerTitle:"",
            editor1Text:"",
            editor2Text:"",
            editor3Text:"",
            offerTitle:"", 
            showTotalPriceStatus:true,
            showTotalDiscountStatus:true,
            showOtherTaxStatus:true,
            isNewOffer:false,
            refNo:"",
            otherTaxes:[],
            orjinalProductList: [],
         
        }
    },
    computed: {
        ...mapState([
            "baseUrl",
        ]),
        ...mapGetters(["localeLang", "token"]),
    },
    methods: {
        formatPrice,
        ...mapActions([]),


        getOffers(){

            axios({
                method:'POST',
                url:'/getOffers',
                baseURL: this.baseUrl,
                data:{
                    dealId:this.dealId
                },
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{


                if(res.data.status.code==0){
                    this.offerData=res.data.content.offer.reverse()
                    this.users=res.data.users

                    for(let i in this.users){
                        for(let j in this.offerData){
                            if(this.offerData[j].cuid.$oid===this.users[i]._id.$oid){
                                this.holderName=this.users[i].name + ' ' + this.users[i].surName         
                            }
                        } 
                    }
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        },
        getEmailTemplates() {
            axios({
                method:'POST',
                url:'/getEmailTemplates',
                baseURL: this.baseUrl,
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==="0"){
                    this.emailTemplates = res.data.content.email_templates;
                    this.organizationName=this.deal.orgId.name
                }else{
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc
                })
                }
            })
        },
        getMatchContacts() {
            this.getOrganization()
            let obj = {};
            obj["search"] = '';
            obj["organizationId"] = this.deal.orgId._id.$oid;
                
            axios({
                method: "POST",
                url: "/quickFilterContact",
                baseURL: this.baseUrl,
                data: obj,
                withCredentials: true,
            })
            .then((res) => {
            return res;
            })
            .then((res) => {
                if (res.data.status.code == 0) {
                    
                }
            });
        },
        getOrganization(){
            let id=this.deal.orgId._id.$oid; 
            this.productTableList=this.deal.productList
            
            axios({
                method:'POST',
                url:'/getOrganization',
                baseURL: this.baseUrl,
                data: {
                    organizationId:id,
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status===false){
                this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                    this.personData=res.data.content.organization.contacts 
                    this.organizationData=res.data.content.organization
                    if(this.isNewOffer==true){
                        this.billAddress=res.data.content.organization.addr
                        this.shippingAddress=res.data.content.organization.addr
                    }
                   
                    
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                    
                }
            })
        },
        selectPerson(){
            this.selected = [];
            this.selectedPersons = [];

            if (!this.selectAll) {
                for (let i in this.personData) {
                    let obj = {}
                    obj.id=this.personData[i]._id.$oid
                    obj.name=this.personData[i].n + " " + this.personData[i].sn
                    this.selectedPersons.push(obj)
                    this.selected.push(this.personData[i]._id.$oid);
                } 
            }
            else{

            }
        },
        matchContactsSave(){
      
            if(this.selectedPersons.length<1){
                this.listPersons=[]
                for(let i in this.selected){
                    for(let j in this.personData){
                        if(this.selected[i]===this.personData[j]._id.$oid){
                        let obj = {}
                        obj.id=this.personData[j]._id.$oid
                        obj.name=this.personData[j].n + " " + this.personData[j].sn
                        this.listPersons.push(obj)
                        }
                    }
                }
            }
            else{
                this.listPersons=[]
                this.listPersons=this.selectedPersons
            }
    
            $("#matchContactsModal").modal("hide");
        },
        deletePerson(index){
            if(this.listPersons.length>1){
                this.selected.splice(index,1)
                this.listPersons.splice(index,1)
            }
            else{
                this.$notify({
                group: "foo",
                type: "warn",
                title: "Kişi alanında en az bir kişinin seçili olması gerekmektedir!",
                });
            }
        },
        quickBidCreate(){
            this.isNewOffer=true
            this.getEmailTemplates()
            this.getOrganization()
            this.listPersons=[]
            this.activityDateAction=""
        },
        redirectToBidScreen(){

            for(let i in this.productTableList){
                let originalProductObj = this.productTableList[i].productId
                let array =[]

                for (const property in this.productTableList[i].productId) {
                    if(this.productTableList[i].productId[property].field_type===12){
                        array.push(this.productTableList[i].productId[property])
                    }
                    originalProductObj['customFieldTaxes']=array
                }
                
                this.orjinalProductList.push(originalProductObj);
            }

            for(let i in this.productTableList){
                if(this.productTableList[i].productId.customFieldTaxes.length>0){
                    let item = this.productTableList[i].productId.customFieldTaxes
                    for(let j in item){
                        let obj = {}
                        obj.name = item[j].name
                        obj.id = item[j]._id
                        if (this.otherTaxes.filter(function(e) { return e.name === item[j].name; }).length > 0) {

                        }
                        else{
                        this.otherTaxes.push(obj)
                        }
                    }
                }
            }


            if(this.listPersons.length<1){
                $('#warningModal').modal('show')
                document.getElementById("warningModalTitle").innerHTML="Gönderilecek Kişi Seçin";
                document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için ilgili kişi alanında en az bir kişinin seçili olması gerekmektedir.";
            }
            else{
                for(let person in this.listPersons){
                    this.personIds.push(this.listPersons[person].id)
                }

                this.offererName=""
                this.offererTitle=""
                this.customerName=""
                this.customerTitle=""
                this.totalAmount = 0
                this.totalDiscount = 0
                this.totalKDV = 0
                this.totalTaxes = 0
                this.generalTotal = 0
                this.subTotal=0
                CKEDITOR.instances["editor1"].setData("");
                CKEDITOR.instances["editor2"].setData("");
                CKEDITOR.instances["editor3"].setData("");

                $("#TeklifEkraniModal").modal("show");
                this.isNewOffer=true
                this.getOrganization()
                this.referenceNo=Math.floor(Math.random() * 899999 + 100000)
                this.bidCreationDate=new Date().toISOString().slice(0, 10)

                for(let i in this.currenciesData){
                    if(this.currenciesData[i].value==this.deal.currency){
                        this.currencyText=this.currenciesData[i].label
                    }
                }
                
                // PRICE CALCULATIONS
                let total=0, discount=0, product=this.deal.productList
                for(let i in product){
                    
                    let kdvPrice=0, totalTaxes=0

                    total=product[i].itemPrice*product[i].quantity
                    discount=(product[i].itemPrice*product[i].quantity*product[i].discountPercentage)/100

                    // FOR CALCULATION OF KDV PRICE
                    if(product[i].productId.tax){
                        kdvPrice = ((total-discount)*product[i].productId.tax)/100
                    }
                    else{
                        kdvPrice = 0
                    }
            
                    // FOR CALCULATION OF CUSTOMFIELD TAXES
                    if(product[i].productId.customFieldTaxes.length>0){
                        let item = product[i].productId.customFieldTaxes

                        for(let j in item){
                            totalTaxes+= (item[j].value*(total-discount))/100
                        }
                        
                    }
    
            
                    this.totalKDV+=kdvPrice
                    this.totalTaxes+=totalTaxes
                    this.productTableList[i].sum = total-discount+kdvPrice+totalTaxes
                    this.totalAmount+=total
                    this.totalDiscount+=discount
                }
                this.generalTotal=(this.totalAmount-this.totalDiscount+this.totalKDV+this.totalTaxes).toFixed(2)
                this.subTotal=this.totalAmount-this.totalDiscount
                this.totalDiscount=this.totalDiscount.toFixed(2)
                this.totalAmount=this.totalAmount.toFixed(2)
            }
              
        },
        saveAndEmail(type){
            console.log("type",type);
            if(this.chosenTemplate===""){
                $('#warningModal').modal('show')
                document.getElementById("warningModalTitle").innerHTML="Şablon Seçin";
                document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için şablon seçili olması gerekmektedir.";
            }
             else if(this.listPersons.length<1 && type =="saveAndEmail"){
                $('#warningModal').modal('show')
                document.getElementById("warningModalTitle").innerHTML="Gönderilecek Kişi Seçin";
                document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için ilgili kişi alanında en az bir kişinin seçili olması gerekmektedir.";
            }
            else if(this.activityDateAction===""){
                $('#warningModal').modal('show')
                document.getElementById("warningModalTitle").innerHTML="Tarih Girin";
                document.getElementById("warningModalText").innerHTML="Teklifin oluşturulması için tarih girilmesi gerekmektedir.";
            }
            else{
                for(let person in this.listPersons){
                    this.personIds.push(this.listPersons[person].id)
                }
                CKEDITOR.instances["editor1"].setData("");
                CKEDITOR.instances["editor2"].setData("");
                CKEDITOR.instances["editor3"].setData("");

                this.offererName=""
                this.offererTitle=""
                this.customerName=""
                this.customerTitle=""
                this.saveOffer(type)
            }
        },
        saveOffer(type){
            let obj = {};
            var emailHead = CKEDITOR.instances["editor1"].getData();
            var termsOfCondition = CKEDITOR.instances["editor2"].getData();
            var emailFooter = CKEDITOR.instances["editor3"].getData();

            if(this.personIds.length<1){
                for(let person in this.listPersons){
                    this.personIds.push(this.listPersons[person].id)
                }
            }
        
            obj["templateId"] = this.chosenTemplate;
            obj["dealId"] = this.dealId;
            obj["offerTitle"] = this.offerTitle;
            obj["organizationId"] = this.deal.orgId._id.$oid;
            obj["contactIds"] = this.personIds;
            obj["expireDate"] = this.activityDateAction;
            obj["billingAddress"] = this.billAddress;
            obj["shipmentAddress"] = this.shippingAddress;
            obj["referenceNo"] = parseInt(this.referenceNo);
            obj["offerDate"] = this.bidCreationDate;
            obj["taxAdministration"] = this.organizationData.taxOffice;
            obj["taxNo"] = this.organizationData.taxNo;
            obj["emailHead"] = emailHead;
            obj["emailFooter"] = emailFooter;
            obj["termsOfCondition"] = termsOfCondition;
            obj["offererSignature"] = "";
            obj["offererName"] = this.offererName;
            obj["offererTitle"] = this.offererTitle;
            obj["customerSignature"] = "";
            obj["customerName"] = this.customerName;
            obj["customerTitle"] = this.customerTitle;
            obj["totalPrice"] = this.generalTotal;
            obj["showTotalPrice"] = this.showTotalPriceStatus;
            obj["showTotalDiscount"] = this.showTotalDiscountStatus;
            obj["showTotalOtv"] = this.showOtherTaxStatus;
        
            if(this.chosenTemplate===""){
                $('#warningModal').modal('show')
                document.getElementById("warningModalTitle").innerHTML="Şablon Seçin";
                document.getElementById("warningModalText").innerHTML="Teklifin gönderilmesi için şablon seçili olması gerekmektedir.";
            }
            else if(this.activityDateAction===""){
                $('#warningModal').modal('show')
                document.getElementById("warningModalTitle").innerHTML="Tarih Girin";
                document.getElementById("warningModalText").innerHTML="Teklifin oluşturulması için son geçerlilik tarihi girilmesi gerekmektedir.";
            }
            else{
                axios({
                    method:'POST',
                    url:'/addOffer',
                    baseURL: this.baseUrl,
                    data: obj,
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.data.status===false){
                    this.$router.push('/logout')
                    }
                    if(res.data.status.code==0){

                        this.$notify({
                        group: "foo",
                        type: "success",
                        title: "Teklif Kaydedildi!",
                        text: res.data.status.desc,
                        });
                        this.offerID=res.data.content.offer._id.$oid
                        this.refNo=res.data.content.offer.referenceNo
                        this.editor1Text=res.data.content.offer.emailHead
                        this.editor2Text=res.data.content.offer.termsOfCondition
                        this.editor3Text=res.data.content.offer.emailFooter

                        if(type==='print'){
                            this.printPdf()
                        }
                        else if(type==='download'){
                            this.downloadPdf()
                        }
                        else if(type==='saveAndEmail'){
                            this.sendEmail()
                        }
                        else{
                           
                        }
                        this.getOffers()
                        $("#TeklifEkraniModal").modal("hide");
                        $("#quickBidCreate").modal("hide");
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc 
                        })
                            
                    }
                })   
            }
        },
        offerCard(index){
            moment.locale(this.localeLang)
            let offerItem
            this.totalAmount = 0
            this.totalDiscount = 0
            this.totalKDV = 0
            this.totalTaxes = 0
            this.generalTotal = 0
            this.subTotal=0
            this.isNewOffer=false
            this.getOrganization()
            this.getEmailTemplates()
            
            $("#TeklifEkraniModal").modal("show");
            offerItem=this.offerData[index]

            this.offerID=offerItem._id.$oid
            this.referenceNo=offerItem.referenceNo
            this.bidCreationDate= moment(offerItem.cratedAt.$date, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true)
            this.activityDateAction= moment(offerItem.expireDate.$date, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('YYYY-MM-DD')
            this.offererName=offerItem.offererName
            this.offererTitle=offerItem.offererTitle
            this.customerName=offerItem.customerName
            this.customerTitle=offerItem.customerTitle
            this.chosenTemplate=offerItem.emailTemplateId.$oid
            this.billAddress=offerItem.billingAddress
            this.shippingAddress=offerItem.shipmentAddress
            this.editor1Text=offerItem.emailHead
            this.editor2Text=offerItem.termsOfCondition
            this.editor3Text=offerItem.emailFooter
            this.offerTitle=offerItem.offerTitle
            this.showTotalDiscountStatus=offerItem.showTotalDiscount
            this.showTotalPriceStatus=offerItem.showTotalPrice

            for(let i in this.currenciesData){
                if(this.currenciesData[i].value==offerItem.deal.currency){
                    this.currencyText=this.currenciesData[i].label
                }
            }
            this.listPersons=[]
            for(let i in offerItem.contacts){
                let obj = {}
                obj.id=offerItem.contacts[i]._id.$oid
                obj.name=offerItem.contacts[i].n + " " + offerItem.contacts[i].sn
                this.listPersons.push(obj)
            }

         
            for(let i in this.productTableList){
                let originalProductObj = this.productTableList[i].productId
                let array =[]
                for (const property in this.productTableList[i].productId) {
                    if(this.productTableList[i].productId[property].field_type===12){
                        array.push(this.productTableList[i].productId[property])
                    }
                    originalProductObj['customFieldTaxes']=array
                }
                this.orjinalProductList.push(originalProductObj);
            }

            for(let i in this.productTableList){
                if(this.productTableList[i].productId.customFieldTaxes.length>0){
                    let item = this.productTableList[i].productId.customFieldTaxes
                    for(let j in item){
                        let obj = {}
                        obj.name = item[j].name
                        obj.id = item[j]._id
                        if (this.otherTaxes.filter(function(e) { return e.name === item[j].name; }).length > 0) {

                        }
                        else{
                        this.otherTaxes.push(obj)
                        }
                    }
                }
            }

            let total=0, discount=0, product=this.deal.productList
            for(let i in product){
                
                let kdvPrice=0, totalTaxes=0

                total=product[i].itemPrice*product[i].quantity
                discount=(product[i].itemPrice*product[i].quantity*product[i].discountPercentage)/100

                // FOR CALCULATION OF KDV PRICE
                if(product[i].productId.tax){
                    kdvPrice = ((total-discount)*product[i].productId.tax)/100
                }
                else{
                    kdvPrice = 0
                }
         
                // FOR CALCULATION OF CUSTOMFIELD TAXES
                if(product[i].productId.customFieldTaxes.length>0){
                    let item = product[i].productId.customFieldTaxes

                    for(let j in item){
                        totalTaxes+= (item[j].value*(total-discount))/100
                    }
                    
                }
 
         
                this.totalKDV+=kdvPrice
                this.totalTaxes+=totalTaxes
                this.productTableList[i].sum = total-discount+kdvPrice+totalTaxes
                this.totalAmount+=total
                this.totalDiscount+=discount
            }
            this.generalTotal=(this.totalAmount-this.totalDiscount+this.totalKDV+this.totalTaxes).toFixed(2)
            this.subTotal=this.totalAmount-this.totalDiscount
            this.totalDiscount=this.totalDiscount.toFixed(2)
            this.totalAmount=this.totalAmount.toFixed(2)
            CKEDITOR.instances["editor1"].setData(this.editor1Text);
            CKEDITOR.instances["editor2"].setData(this.editor2Text);
            CKEDITOR.instances["editor3"].setData(this.editor3Text);

        },
        
        createPdf() {
            axios({
                method:'POST',
                url:'/createOfferPdf',
                baseURL: this.baseUrl,
                data: {
                    templateId: this.chosenTemplate,
                    offerId:this.offerID
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status === "OK" ){
                    this.pdfUrl = []
                    this.pdfUrl.push(res.data.url)
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        sendEmail() {
            this.createPdf()
           
            this.personEmailsArray=[]
            for (let i in this.listPersons) {
                for(let j in this.personData){
                    if(this.listPersons[i].id===this.personData[j]._id.$oid){
                        this.personEmailsArray.push(this.personData[j].email[0])
                    } 
                }
            } 

            let msg = this.editor1Text + "\n \n" + this.editor2Text + "\n \n" + this.editor3Text           

            setTimeout(() => {
                this.$router.push({ path: '/email', query: { 
                    action: 'login' ,
                    emailAddress: this.personEmailsArray ,
                    subject: "Teklifiniz Oluşturuldu. RefNo: " + this.refNo ,
                    message: msg,
                    attachments: this.pdfUrl,
                }})
            }, 1500);      
        
        },
            
        printPdf() {
            axios({
                method:'POST',
                url:'/createOfferPdf',
                baseURL: this.baseUrl,
                data: {
                    templateId: this.chosenTemplate,
                    offerId: this.offerID
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status === "OK" ){
                    var id = "iframe", frame = document.createElement("iframe");
                    frame.setAttribute("id", id);
                    frame.setAttribute("name", "printframe");
                    frame.setAttribute("hidden", true);
                    document.body.appendChild(frame);
                    frame.onload = function() {
                        setTimeout(function() {
                        printframe.print()
                        },1000)
                    }
                    frame.setAttribute("src", res.data.relative_url);
                   
                } else {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc
                })
                }
            })
        },
        downloadPdf(){
            axios({
                method:'POST',
                url:'/createOfferPdf',
                baseURL: this.baseUrl,
                data: {
                    templateId: this.chosenTemplate,
                    offerId:this.offerID
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status === "OK" ){
                    this.pdfUrl = []
                    this.pdfUrl.push(res.data.url)
                    window.open(res.data.url, '_blank')
                }else{
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc
                    })
                }
            })
        },
        offerVersion:function(index){
            let version 
            let num = this.offerData.length-index

            if(num<10){
                version = "V.0" + num.toString()
            }
            else{
                version = "V." + num.toString()
            }

            return (version)
        },
        offerDateFunc:function(index,type){
            let date, item = this.offerData[index]

            if(type==='expire'){
                date = moment(item.expireDate.$date, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('L')
            }
            else if(type==='add'){
                date = moment(item.cratedAt.$date, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('L')
            }
            else if(type==='send'){
                if(item.isOffered==true){
                    date = moment(item.offerDate.$date, "YYYY-MM-DDTHH:mm:ss.SSSSZ", true).format('L')
                }
                else{
                    date = '-'
                }
            }

            return (date)
        },
        chooseTemplate(event){
            this.chosenTemplate=this.emailTemplates[event.target.selectedIndex-1]._id
        },
        createNewTemplate(){
            window.open('/emailTemplateEditor/' + 'new' , '_blank');
        },
        warningModalClose(){
            $('#warningModal').modal('hide')
        },

  
    },
    mounted(){
        this.getOffers()
        $('.modal').attr('tabindex', '');
        CKEDITOR.replace('editor1', {
            height: 150,
            toolbarGroups: 
                [
                    {
                    "name": "basicstyles",
                    "groups": ["basicstyles"]
                    }, 
                    { 
                    "name": 'clipboard', 
                    "groups": [ 'undo' ] },  
                    { 
                    "name": 'paragraph',
                    "groups": ['align'] },
                    {
                    "name": "styles",
                    "groups": ["styles"]
                    },
                    {
                    "name": 'colors', 
                    "groups": [ 'colors' ] 
                    },
                    {
                    "name": 'insert', 
                    "groups": [ 'insert' ] 
                    },
                    { 
                    "name": 'links',
                    "groups": [ 'links' ] 
                    },
                ],

            removeButtons: 'Copy,Paste,PasteFromWord,PasteText,Subscript,Superscript,Styles,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe'
        });
        CKEDITOR.replace('editor2', {
            height: 150,
            toolbarGroups: 
                [
                    {
                    "name": "basicstyles",
                    "groups": ["basicstyles"]
                    }, 
                    { 
                    "name": 'clipboard', 
                    "groups": [ 'undo' ] },  
                    { 
                    "name": 'paragraph',
                    "groups": ['align'] },
                    {
                    "name": "styles",
                    "groups": ["styles"]
                    },
                    {
                    "name": 'colors', 
                    "groups": [ 'colors' ] 
                    },
                    {
                    "name": 'insert', 
                    "groups": [ 'insert' ] 
                    },
                    { 
                    "name": 'links',
                    "groups": [ 'links' ] 
                    },
                ],

            removeButtons: 'Copy,Paste,PasteFromWord,PasteText,Subscript,Superscript,Styles,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe'
        });
        CKEDITOR.replace('editor3', {
            height: 150,
            toolbarGroups: 
                [
                    {
                    "name": "basicstyles",
                    "groups": ["basicstyles"]
                    }, 
                    { 
                    "name": 'clipboard', 
                    "groups": [ 'undo' ] },  
                    { 
                    "name": 'paragraph',
                    "groups": ['align'] },
                    {
                    "name": "styles",
                    "groups": ["styles"]
                    },
                    {
                    "name": 'colors', 
                    "groups": [ 'colors' ] 
                    },
                    {
                    "name": 'insert', 
                    "groups": [ 'insert' ] 
                    },
                    { 
                    "name": 'links',
                    "groups": [ 'links' ] 
                    },
                ],

            removeButtons: 'Copy,Paste,PasteFromWord,PasteText,Subscript,Superscript,Styles,Flash,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe'
        });
        
    }
}
</script>

<style scoped>
label{
    margin: 0px;
}
.black {
  color: #000000 !important;
}
.disBorder{
    border: 1px solid #D1D1D7;
    box-sizing: border-box;
    overflow-y: auto;
}
.borderr{
    background-color: #FAFAFA;
    border-radius: 4px 0px 0px 4px;
    height: 36px;
}
.h72{
    height: 72px;
}
.modal-header{
    background: #D7E3F4;
    font-size: 23px;
}
.modal-body{
    background: #F1F5FB;
}
.new-label{
    color: #707b88;
    font-size: 16px;
    font-weight: 500;
}
.personTable {
  min-height: 350px;
  min-width: 655px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 4px;
}
.listPerson {
  display: flex;
  background: #E9EAEB;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  align-items: center;
}
.border {
  border: 1px solid #a5abb3;
  box-sizing: border-box;
  border-radius: 8px;
}
.companyInfo{
    background: #F8F9FA;
    font-size: 16px;
    font-weight: 700;
    padding: 1rem;
    color: #000;
    border-radius: 8px;
}
.logo {
  width: 149px;
  height: 102px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}
#matchContactsModal{
    z-index: 9999;
}
.card:hover{
    transition: all 0.2s ease-out;
    box-shadow: 0px 4px 8px rgba(38, 38, 38, 0.2);
    top: -4px;
    border: 1px solid #cccccc;
    background-color: white;
}

</style>
